<template>
  <Modal
    :id="'cmp-settings-task-template-form'"
    @cancelled="onCancel"
  >
    <template slot="header">
      {{taskHeader}} <br/>
      <template v-if="mode=='edit'">{{ task.source }}</template>

    </template>

    <template slot="body">
        <TextField
          class="m1"
          :id="'task'"
          v-bind="textFieldConfig"
          :value="task.task"
          :placeholder="$t('task')"
          @valuechanged="onTextFieldValueChange"
        />
        <Dropdown
          :options="usersTV"
          class="m2"
          :selected="assignedUserSelectedTV"
          :placeholder="$t('assigned_user')"
          v-on:selectedChange="e => onDropdownChange('assigned_user', e)"
          :listHeight="120"
          box
          multiple
        />
        <TextField
          class="m1"
          :id="'notes'"
          v-bind="textFieldConfig"
          :value="task.notes"
          :placeholder="$t('notes')"
          @valuechanged="onTextFieldValueChange"
        />



        <TextField
          type="date"
          id="due_date"
          class="m1"
          :placeholder="$t('due_date')"
          :value="task.due_date"
          @valuechanged="onTextFieldValueChange"
        />

        <template v-for="(item,index) in task.json_extra_fields">
            <template v-if="item.data_type=='decimal'">
              <TextField
                class="m1 number"
                :id="index"
                :type="'number'"
                v-bind="textFieldConfig"
                :value="item.field_data"
                :validators="decimalValidators"
                :placeholder="item.field_name"
                @valuechanged="onExtraFieldValueChange"
                @validated="onValidation"
                :showValidationIcons="true" 
                :immediateValidation="true"
              />
              <!--  -->
              <!-- :disable="true" -->
            </template>
            <template v-if="item.data_type=='int'">
              <TextField
                class="m1 number"
                :id="index"
                :type="'number'"
                v-bind="textFieldConfig"
                :value="item.field_data"
                :validators="intValidators"
                :placeholder="item.field_name"
                @valuechanged="onExtraFieldValueChange"
                @validated="onValidation"
                :showValidationIcons="true" 
                :immediateValidation="true"
                
              />
              <!--  -->
              <!-- :disable="true" -->
            </template>
            
            <template v-if="item.data_type=='email'">
              <TextField
                class="m1"
                :id="index"
                v-bind="textFieldConfig"
                :value="item.field_data"
                :validators="emailValidators"
                :placeholder="item.field_name"
                @valuechanged="onExtraFieldValueChange"
                @validated="onValidation"
                :showValidationIcons="true" 
                :immediateValidation="true"
              />
              <!-- :disable="true" -->
            </template>
            <template v-if="item.data_type=='text'">
              <TextField
                class="m1"
                :id="index"
                
                v-bind="textFieldConfig"
                :value="item.field_data"
                :placeholder="item.field_name"
                @valuechanged="onExtraFieldValueChange"
                :showValidationIcons="true" 
                :immediateValidation="true"
                
              />
              <!-- :disable="true" -->
            </template>
            <template v-if="item.data_type=='text_box'">
              <TextField
                class="m1"
                :id="index"
                textarea
              
                v-bind="textFieldConfig"
                :value="item.field_data"
                :placeholder="item.field_name"
                :height="100"
                @valuechanged="onExtraFieldValueChange"
                :showValidationIcons="true" 
                :immediateValidation="true"
              />
            </template>
            <template v-if="item.data_type=='date'">
              <TextField
                class="m1"
                :id="index"
                type="date"
               
                :value="item.field_data"
                :placeholder="item.field_name"
                :showValidationIcons="true" 
                :immediateValidation="true"
                @valuechanged="onExtraFieldValueChange"
                
              />
            <!-- :validators="dateValidators" -->
            <!-- @validated="onValidation" -->
            </template>
            <template v-if="item.data_type=='check_box'">
              <DTCheckbox
                :id="item.field_name"
                :label="item.field_name"
                :checked="item.field_data==1||item.field_data=='1'"
                @click="e=>onCheckboxChange(index,e)"
                :minH="'42px'"
                :class="'ml0'"
              />
              <!-- :disable="true" -->
            </template>
        </template>

        <TextField
          v-if="task.external_table!='booking' && mode=='edit'"
          class="m1"
          :id="'from'"
          v-bind="textFieldConfig"
          :value="task.users"
          :placeholder="$dft.capHead($t('from'))"
          @valuechanged="onTextFieldValueChange"
          :showValidationIcons="false"
          :immediateValidation="true"
          :disabled="true"
         
        />

    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" 
        @click.stop="onTaskTemplateSubmit"
        :class="{ disabled: !IsFormValid }"
        :disabled="!IsFormValid"
      >
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { dtTaskService } from "../../../../dt-plugins/dt-task/dt-task-service"
import { taskService } from "../../services/tasks.service";
import isEmail from "validator/lib/isEmail";
import isFloat from "validator/lib/isFloat";
import isInt from "validator/lib/isInt";
import { createValidator } from "@plugins/text-field";
import { decimalValidators ,intValidators,emailValidators} from "../../../../utility/custom.validator"
export default {
  components: {
    Modal
  },
  props: {
    existingTask: {
      type: Object,
      default: () => {}
    },
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
      task:  {
        task: "",
        due_date: "",
        assigned_user: "",
        sent_user: "",
        status: "open",
        notes: "",
        external_table:"general"
      },

      taskHeader:'',

      emailValidators:emailValidators,
      intValidators:intValidators,
      decimalValidators:decimalValidators,
      formData: {},
      jsonValidationResult: {},
    };
  },
  mounted: async function() {
    const formData = await taskService.tasksTab();
    this.formData = formData.data;
    console.log("POIUUYJHG",this.formData)

    if(this.mode=='edit'){
      this.task ={
        ...this.existingTask,
        assigned_user:this.existingTask.assigned_users
      }

      this.taskHeader = this.task.task
    }
  },
  computed: {
    usersTV(){
      return (this.formData?.users || []).map(r => ({text: r.user_name, value: r.user_id}));
    },
    assignedUserSelectedTV(){
      const assignedUserArr = this.task?.assigned_user ? this.task.assigned_user.split(',') : [];
      console.log("::::::::::::::::::assignedUserArr",assignedUserArr,this.task?.assigned_user)
      return this.usersTV.filter( userTV => assignedUserArr.includes("" + userTV.value) ) || [];
    },

    mode(){
      return this.$route.query.mode
    },
    IsFormValid: function () {
      return Object.values(this.jsonValidationResult).every((e) => e.valid)
    },
  },
  methods: {
    onTaskTemplateSubmit: function() {
      
      if(this.mode=='add'){
        this.$emit("insert", {
          ...this.task
        });

      }else{
        const editedTask = { ...this.task , extra_fields:JSON.stringify(this.task?.json_extra_fields)||[] }
        console.log(editedTask,":::::::::::")

        dtTaskService.updateSingleTaskExtraFiled({...editedTask});
        dtTaskService.updateSingleTask({...editedTask});

      }

      this.onCancel();

    },

    onValidation: function (name, value) {
      // console.log("per validate", { name, value });
      this.$set(this.jsonValidationResult, name, value);
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function(id, value) {
      this.task[id] = value;

      if(this.mode=='edit'){

         // this.emitUpdate({name:id,value:value})


      }
    },
    onDropdownChange: function(name, value) {
      let val = value.value;
      let namevalue = "";
      if(['assigned_user', 'local_detail_type_ids'].includes(name)){
        val = value.map(r => r.value).join();
        namevalue =value.map(r => r.text).join();
        
        console.log("val",value)
        name = 'assigned_user'
      }
      this.task[name] = val;
      if(this.mode=='edit'){
        console.log('EDIT',{name:name,value:val})
       // this.emitUpdate({name:name,value:val,namevalue:namevalue})
      }
    },
    onCheckboxChange: function(name, event) {
      const value = event.target.checked ? "1" : "0";
      this.task[name] = value
      if(this.mode=='edit'){
      //  this.emitUpdate({name:name,value:value})
      }
    },

    emitUpdate:function({name,value,namevalue}){
      console.log("emit",{name,value})
      this.$emit("update", {
        name: name,
        item: this.task,
        value: value,
        namevalue:namevalue
      });
    },

    onExtraFieldValueChange:function(e,value){
      this.task.json_extra_fields[e].field_data=value
      console.log(this.extra_fields,"EXTRA FIELD")
     // this.$emit('update',{ name:'extra_field',value:this.extra_fields,item:this.task })
    }

  }
};
</script>

<style lang="scss">
.cmp-settings-task-template-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
